import { useMutation } from '@apollo/client';
import React, { useState, useCallback } from 'react';
import { Button } from '@moda/om';
import { reportError } from '../../lib/reportError';
import {
  UpdateNotificationPreferencesMutationInput,
  UPDATE_NOTIFICATION_PREFERENCES_MUTATION
} from './unsubscribePage.rest';

enum Mode {
  Resting,
  Saving,
  Error,
  Updated
}

type UnsubscribePageUpdateButtonProps = {
  input: UpdateNotificationPreferencesMutationInput;
  onUpdated?(): void;
};

export const UnsubscribePageUpdateButton: React.FC<UnsubscribePageUpdateButtonProps> = ({
  input,
  onUpdated
}) => {
  const [mode, setMode] = useState(Mode.Resting);

  const [updateNotificationPreferences] = useMutation(UPDATE_NOTIFICATION_PREFERENCES_MUTATION);

  const handleClick = useCallback(async () => {
    setMode(Mode.Saving);
    try {
      await updateNotificationPreferences({ variables: { input } });
      setMode(Mode.Updated);
      onUpdated?.();
    } catch (error) {
      setMode(Mode.Error);
      reportError('UNSUBSCRIBE_PAGE_UPDATE', error);
    }
  }, [input, onUpdated, updateNotificationPreferences]);

  const label = {
    [Mode.Resting]: 'Update Preferences',
    [Mode.Updated]: 'Update Preferences',
    [Mode.Saving]: 'Updating Preferences…',
    [Mode.Error]: 'Problem Saving Your Preferences'
  }[mode];

  return (
    <Button onClick={handleClick} disabled={mode === Mode.Saving}>
      {label}
    </Button>
  );
};
